(() => {
  function initKymeeSwipers(context = document) {
    if (window.innerWidth > 789 || typeof Swiper === "undefined") return;

    const cards = context.querySelectorAll(".product-grid .card-wrapper");

    cards.forEach((card) => {
      // 🔒 HARD CARD GUARD
      if (card.dataset.swiperInit === "1") return;

      const media = card.querySelector(".card__media .media");
      if (!media) return;

      // 🔒 HARD MEDIA GUARD
      if (media.classList.contains("swiper-initialized")) return;

      card.dataset.swiperInit = "1";
      media.classList.add("swiper-container");

      // ✅ Build wrapper only once
      if (!media.querySelector(".swiper-wrapper")) {
        const wrapper = document.createElement("div");
        wrapper.className = "swiper-wrapper";

        const frag = document.createDocumentFragment();
        while (media.firstChild) frag.appendChild(media.firstChild);
        wrapper.appendChild(frag);
        media.appendChild(wrapper);
      }

      media
        .querySelectorAll(".swiper-wrapper > *")
        .forEach((el) => el.classList.add("swiper-slide"));

      // ✅ PAGINATION GUARD (MOST IMPORTANT)
      let pagination = media.querySelector(".swiper-pagination");
      if (!pagination) {
        pagination = document.createElement("div");
        pagination.className = "swiper-pagination swiper-pagination-progressbar";
        media.appendChild(pagination);
      }

      requestIdleCallback(() => {
        const swiper = new Swiper(media, {
          slidesPerView: 1,
          spaceBetween: 10,
          watchOverflow: true,
          pagination: {
            el: pagination,
            type: "progressbar",
          },
          on: {
            init() {
              if (this.slides.length <= 1) {
                pagination.style.display = "none";
              }
            },
          },
        });

        media.classList.add("swiper-initialized");
      }, { timeout: 500 });
    });
  }

  function observeProductGrid() {
    if (window.__kymeeSwiperObserverAttached) return;
    window.__kymeeSwiperObserverAttached = true;

    const grid = document.querySelector(".product-grid");
    if (!grid) return;

    const observer = new MutationObserver((mutations) => {
      const hasNewCards = mutations.some((m) =>
        [...m.addedNodes].some(
          (n) =>
            n.nodeType === 1 &&
            (n.classList?.contains("card-wrapper") ||
              n.querySelector?.(".card-wrapper"))
        )
      );

      if (hasNewCards) {
        requestIdleCallback(() => initKymeeSwipers(grid), { timeout: 600 });
      }
    });

    observer.observe(grid, { childList: true, subtree: true });

    requestIdleCallback(() => initKymeeSwipers(grid), { timeout: 600 });
  }

  document.addEventListener("DOMContentLoaded", observeProductGrid);
  document.addEventListener("ajaxinate:loaded", () => initKymeeSwipers(document));

  document.addEventListener("kymee:collection:reset", () => {
    // 🔥 FULL RESET
    document.querySelectorAll(".card-wrapper").forEach((card) => {
      delete card.dataset.swiperInit;
      const media = card.querySelector(".card__media .media");
      media?.classList.remove("swiper-initialized");
    });

    window.__kymeeSwiperObserverAttached = false;

    requestAnimationFrame(() => {
      observeProductGrid();
      initKymeeSwipers(document);
    });
  });
})();
